import React, { useEffect, useMemo, useState } from 'react';
import { UIRouter } from '@uirouter/core';
import { RouterContext } from '../context';
import { clientPlugin } from '../../plugins/client';
export function Router(props) {
  const {
    children,
    $$router$$,
    $$router_methods$$
  } = props;
  const router = useMemo(() => {
    const router = new UIRouter();
    router.plugin(clientPlugin($$router$$.location));
    for (const state in $$router$$.states) {
      router.stateRegistry.register($$router$$.states[state]);
    }
    return router;
  }, []);
  const [state, setState] = useState({
    router,
    ...$$router$$,
    ...$$router_methods$$
  });
  useEffect(() => {
    setState(state => ({
      ...state,
      current: $$router$$.current
    }));
  }, [JSON.stringify($$router$$.current)]);
  useEffect(() => {
    return () => router.dispose();
  }, []);
  return /*#__PURE__*/React.createElement(RouterContext.Provider, {
    value: state
  }, children);
}
Router.displayName = 'Router';
//# sourceMappingURL=Router.js.map